export const opModeNameColors: { [name: string]: string } = {
	dp: "#193cbc",
	"dp/standby": "#193cbc",
	operation: "#193cbc",
	standby: "#4382c8",
	port: "#84afdc",
	"port - maneuvering": "#84afdc",
	"port - moored": "#c5dff2",
	"transit other": "#ab6f63", //"#b6b6b6",
	"transit eco": "#2ca02c",
	"transit manuvering": "#ffd700",
	"transit service": "#ffd700",
	"transit max": "#f47e68",
	loading: "#745c9b",
	unloading: "#5422a7",
	ah: "#745c9b",
	"anchor handling": "#745c9b",
	tow: "#5422a7",
	//unisea modes
	"dp operations": "#193cbc",
	"in port (incl. mob/demob and at anchor)": "#84afdc",
	"standby on location and/or waiting on weather": "#4382c8",
	"transit service speed": "#ffd700",
	//altera modes
	"dp 1000m": "#0050ac",
	"dp maneuvering": "#3794b6",
	"drift/waiting": "#ffd600",
	"port/loading": "#b9dbdc",
	discharge: "#999999",
	anchorage: "#e3365c",
	manuvering: "#3794b6",
	"sailing ballast": "#b0d757",
	"sailing laden": "#f47e68",
	"(na)": "#ffffff",
	"unknown mode": "#949191", //"#f20acbaa",
}

export function getColorOfOpModeName(opModeName: string) {
	const lowerCaseOpModeName = opModeName.toLowerCase()
	if (lowerCaseOpModeName in opModeNameColors) {
		return opModeNameColors[lowerCaseOpModeName]
	}
	return undefined
}

export const sortedModesOrder: { [key: string]: number } = {
	DP: 10,
	"DP/Standby": 11,
	Operation: 12,

	Standby: 20,

	Port: 30,
	"Port - maneuvering": 31,
	"Port - moored": 32,

	"Transit eco": 41,
	"Transit manuvering": 42,
	"Transit service": 43,
	"Transit max": 44,
	"Transit other": 45,

	Loading: 50,
	Unloading: 60,
	AH: 70,
	Tow: 80,

	//ALTERA MODES
	"DP 1000m": 10,
	"DP Maneuvering": 15,
	"Drift/waiting": 20,
	"Port/loading": 30,
	Discharge: 40,
	Anchorage: 50,
	Manuvering: 14,
	"Sailing ballast": 70,
	"Sailing laden": 80,
}
